<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <header class="bg-blue-600 top-header">
        <nav
            class="max-full mx-auto px-4 sm:px-6 lg:px-8 shadow-lg"
            aria-label="Top"
        >
            <div
                class="w-full py-6 flex items-center justify-between border-b border-blue-500 lg:border-none"
            >
                <div class="flex items-center">
                    <a class="not-hidden mr-8" v-if="user" href="/">
                        <span class="sr-only">{{ user.name }}</span>
                        <logo-nl
                            height="h-10"
                            class="h-10"
                            color="white"
                        ></logo-nl>
                    </a>
                    <div class="hidden no-ml-10 space-x-8 lg:block">
                        <router-link
                            v-for="link in navigation"
                            :key="link.name"
                            :to="{ name: link.href }"
                            class="inline-block py-2 px-4 border border-transparent rounded-md text-base font-medium text-white hover:bg-opacity-75"
                            :class="[
                                checkCurrent(link.href) ||
                                navigation.length == 1
                                    ? 'bg-white text-blue-600'
                                    : 'bg-blue-500 text-white',
                                '',
                            ]"
                        >
                            {{ link.name }}
                        </router-link>
                    </div>
                </div>
                <div class="ml-10 space-x-4">
                    <span
                        v-if="company && !languagePicker"
                        @click="openMyProfile()"
                        class="inline-block bg-blue-800 hover:bg-blue-700 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white cursor-pointer relative"
                    >
                        <img
                            class="inline-flex rounded-full h-8 w-8 -mt-1 -ml-2 absolute rounded-full bg-blue-500"
                            :alt="initials"
                            v-if="avatar"
                            :src="avatar"
                        />
                        <span
                            class="inline-flex items-center justify-center h-8 w-8 -mt-1 -ml-2 absolute rounded-full bg-blue-500"
                            v-if="!avatar"
                        >
                            <span
                                class="font-medium text-base leading-none text-white"
                                >{{ initials }}</span
                            >
                        </span>
                        <span
                            class="absolute inset-0 shadow-inner rounded-full"
                            aria-hidden="true"
                        />
                        <span class="ml-8">
                            {{ company }}
                        </span>
                    </span>
                    <router-link
                        :to="{
                            name: 'proxyvoting',
                        }"
                        replace
                        v-if="proxyVoting && !languagePicker"
                        class="inline-block bg-blue-900 hover:bg-blue-800 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white cursor-pointer"
                    >
                        <span v-if="proxyTransfer">
                            {{ t("proxy-vote.menu-transfer", "Volmachten") }}
                        </span>
                        <span v-if="proxyRevoke">
                            {{
                                t(
                                    "proxy-vote.menu-revoke",
                                    "Volmacht intrekken"
                                )
                            }}
                        </span>
                    </router-link>

                    <a
                        @click="languagePicker = !languagePicker"
                        v-if="showLocaleSwitcher && !languagePicker"
                        class="inline-block bg-blue-100 hover:bg-blue-200 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white cursor-pointer"
                        >{{ currentLocale }}</a
                    >

                    <div
                        v-if="languagePicker"
                        class="inline-block bg-blue-100 hover:bg-blue-200 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white"
                    >
                        <a
                            @click="setLocale('nl')"
                            class="transform hover:scale-75 hover:rotate-12 skew-y-3 cursor-pointer pr-1"
                            v-if="showLocaleSwitcher"
                            >🇳🇱</a
                        >
                        <span class="text-base font-medium text-blue-700">
                            {{ t("menu.locale-switcher-or", "of") }}</span
                        >
                        <a
                            @click="setLocale('de')"
                            class="transform hover:scale-75 hover:rotate-12 hover:skew-y-3 cursor-pointer pl-1"
                            v-if="showLocaleSwitcher"
                            >🇩🇪</a
                        >
                        <span class="text-base font-medium text-blue-700">
                            {{ t("menu.locale-switcher-or", "of") }}</span
                        >
                        <a
                            @click="setLocale('en')"
                            class="transform hover:scale-75 hover:rotate-12 hover:skew-y-3 cursor-pointer pl-1"
                            v-if="showLocaleSwitcher"
                            >🇬🇧</a
                        >
                    </div>

                    <a
                        href="/logoff"
                        class="inline-block bg-white py-2 px-4 border border-transparent rounded-md text-base font-medium text-blue-600 hover:bg-blue-50"
                        >{{ t("logoff", "Uitloggen") }}</a
                    >
                </div>
            </div>
            <div class="py-4 flex flex-wrap justify-center space-x-6 lg:hidden">
                <router-link
                    v-for="link in navigation"
                    :key="link.name"
                    :to="{ name: link.href }"
                    class="text-base font-medium text-white hover:text-blue-50"
                    :class="[checkCurrent(link.href) ? 'underline' : '', '']"
                >
                    {{ link.name }}
                </router-link>
            </div>
        </nav>
    </header>
</template>
<script>
export default {
    mounted() {
        this.setMenu();
        Eventing.listen("toggleProxy", () => this.toggleProxyStatus());
        this.defineProxyVoting();
        this.setCurrentLocale();

        this.showLocaleSwitcher =
            document.head.querySelector('meta[name="locale_switcher"]')
                .content == "true"
                ? false
                : true;
    },
    props: ["user"],
    data() {
        return {
            company: null,
            proxyVoting: true,
            proxyTransfer: false,
            proxyRevoke: false,
            navigation: [{ name: "Dashboard", href: "dashboard" }],
            currentLocale: null,
            showLocaleSwitcher: false,
            languagePicker: false,
            initials: null,
            avatar: null,
        };
    },
    methods: {
        openMyProfile() {
            Eventing.fire("openMyProfile");
        },
        setLocale(locale) {
            axios
                .post("/auth?view=app", { switchLocale: locale })
                .then((response) => {
                    if (response.data.user) {
                        window.location.reload();
                    } else {
                        this.$router.push("/login");
                    }
                })
                .catch((error) => {
                    if (error.response.status > 400) {
                        this.$router.push("/login");
                    }
                });
        },
        setCurrentLocale() {
            var lang = document.documentElement.lang;
            if (lang == "nl") {
                this.currentLocale = "🇳🇱";
            }
            if (lang == "de") {
                this.currentLocale = "🇩🇪";
            }
            if (lang == "en") {
                this.currentLocale = "🇬🇧";
            }
        },
        defineProxyVoting() {
            this.proxyVoting =
                document.head.querySelector('meta[name="show_proxy_voting"]')
                    .content == "true"
                    ? true
                    : false;

            if (this.proxyVoting) {
                var isProxied =
                    document.head.querySelector(
                        'meta[name="proxy_vote_status"]'
                    ).content == "true"
                        ? true
                        : false;
                this.proxyTransfer = !isProxied;
                this.proxyRevoke = isProxied;
            }
        },
        toggleProxyStatus() {
            this.proxyVoting = false;
            this.proxyTransfer = !this.proxyTransfer;
            this.proxyRevoke = !this.proxyRevoke;
            try {
                document.head.querySelector(
                    'meta[name="voting_weight"]'
                ).content = 0;
            } catch (error) {}
        },
        setMenu() {
            if (this.user.is_moderator) {
                this.navigation = [
                    { name: "Dashboard", href: "dashboard" },
                    { name: "Vergaderingen", href: "meetings" },
                    { name: "Deelnemers", href: "attendees" },
                    { name: "Instellingen", href: "profile" },
                ];

                this.navigation = [
                    {
                        name: this.t("navigation.dashboard", "Dashboard"),
                        href: "dashboard",
                    },
                    {
                        name: this.t(
                            "navigation.vergaderingen",
                            "Vergaderingen"
                        ),
                        href: "meetings",
                    },
                    {
                        name: this.t("navigation.deelnemers", "Deelnemers"),
                        href: "attendees",
                    },
                    {
                        name: this.t("navigation.mailings", "Mailings"),
                        href: "mailings-index",
                    },
                    {
                        name: this.t("navigation.instellingen", "Instellingen"),
                        href: "profile",
                    },
                ];

                if (
                    document.head.querySelector('meta[name="members_type"]')
                        .content == "leden"
                ) {
                    this.navigation = [
                        {
                            name: this.t("navigation.dashboard", "Dashboard"),
                            href: "dashboard",
                        },
                        {
                            name: this.t(
                                "navigation.members",
                                "Ledenadministratie"
                            ),
                            href: "members",
                        },
                        {
                            name: this.t(
                                "navigation.vergaderingen",
                                "Vergaderingen"
                            ),
                            href: "meetings",
                        },
                        {
                            name: this.t("navigation.mailings", "Mailings"),
                            href: "mailings-index",
                        },
                        {
                            name: this.t(
                                "navigation.instellingen",
                                "Instellingen"
                            ),
                            href: "profile",
                        },
                    ];
                }
            } else if (this.user.is_superadmin) {
                this.navigation = [
                    { name: "Dashboard", href: "dashboard" },
                    { name: "Vergaderingen", href: "meetings" },
                    { name: "Deelnemers", href: "attendees" },
                    { name: "Instellingen", href: "profile" },
                    { name: "Backstage", href: "backstage" },
                ];

                this.navigation = [
                    {
                        name: this.t("navigation.dashboard", "Dashboard"),
                        href: "dashboard",
                    },
                    {
                        name: this.t(
                            "navigation.vergaderingen",
                            "Vergaderingen"
                        ),
                        href: "meetings",
                    },
                    {
                        name: this.t("navigation.deelnemers", "Deelnemers"),
                        href: "attendees",
                    },
                    {
                        name: this.t("navigation.instellingen", "Instellingen"),
                        href: "profile",
                    },
                    {
                        name: this.t("navigation.mailings", "Mailings"),
                        href: "mailings-index",
                    },

                    {
                        name: this.t("navigation.backstage", "Backstage"),
                        href: "backstage",
                    },
                ];

                if (
                    document.head.querySelector('meta[name="members_type"]')
                        .content == "leden"
                ) {
                    this.navigation = [
                        {
                            name: this.t("navigation.dashboard", "Dashboard"),
                            href: "dashboard",
                        },
                        {
                            name: this.t(
                                "navigation.members",
                                "Ledenadministratie"
                            ),
                            href: "members",
                        },
                        {
                            name: this.t(
                                "navigation.vergaderingen",
                                "Vergaderingen"
                            ),
                            href: "meetings",
                        },
                        {
                            name: this.t("navigation.mailings", "Mailings"),
                            href: "mailings-index",
                        },
                        {
                            name: this.t(
                                "navigation.instellingen",
                                "Instellingen"
                            ),
                            href: "profile",
                        },
                        {
                            name: this.t("navigation.backstage", "Backstage"),
                            href: "backstage",
                        },
                    ];
                }
            } else {
                this.navigation = [
                    {
                        name: this.t("navigation.dashboard", "Dashboard"),
                        href: "dashboard",
                    },
                ];
            }
            this.setCompany();
        },
        checkCurrent(route) {
            return this.$route.name.split("-")[0].includes(route.split("-")[0])
                ? true
                : false;
        },
        setCompany() {
            try {
                this.company = document.head.querySelector(
                    'meta[name="company"]'
                ).content;
            } catch (error) {}
            this.setUser();
        },
        setUser() {
            try {
                this.avatar = document.head.querySelector(
                    'meta[name="avatar"]'
                ).content;
            } catch (error) {}
            try {
                this.initials = document.head.querySelector(
                    'meta[name="initials"]'
                ).content;
            } catch (error) {}
        },
    },
};
</script>
